import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-brackets-curly" }, null, -1 /* HOISTED */);
import Session from "js/Session";
import { useErrorDetail } from "./useErrorDetail";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ErrorNotificationContent',
    props: {
        error: {}
    },
    emits: ["opened", "closed"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const isSuperUser = computed(() => {
            return Session.getInstance().isSuperUser();
        });
        const emit = __emit;
        const { setError } = useErrorDetail();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createTextVNode(_toDisplayString(_ctx.error.message) + " ", 1 /* TEXT */),
                (isSuperUser.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        _createTextVNode(" - "),
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(setError)(_ctx.error)))
                        }, [
                            _createTextVNode("View Details "),
                            _hoisted_2
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
